(function () {
  'use strict';

  function initRelatedProducts() {
    var container = document.getElementById('related-range-products');
    var grid = document.getElementById('related-products-grid');

    if (!container || !grid) return;

    var title = container.getAttribute('data-product-title') || '';
    var currentHandle = container.getAttribute('data-product-handle') || '';
    var range = title.trim().split(/[\s:]+/)[0];

    if (range.length < 3) return;

    var originalCards = Array.prototype.slice.call(
      grid.querySelectorAll('.grid__item')
    );

    var url = '/search/suggest.json?q=' +
      encodeURIComponent(range) +
      '&resources[type]=product' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=last';

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.json();
      })
      .then(function (data) {
        var products = (
          data.resources &&
          data.resources.results &&
          data.resources.results.products
        ) || [];

        var selected = [];
        var seen = {};

        seen[currentHandle] = true;

        products.forEach(function (item) {
          if (selected.length >= 4) return;

          var firstWord = (item.title || '')
            .trim()
            .split(/[\s:]+/)[0];

          if (firstWord.toLowerCase() !== range.toLowerCase()) return;
          if (!item.handle || seen[item.handle]) return;

          seen[item.handle] = true;
          selected.push(item);
        });

        // Keep the original recommendations as fallback.
        if (!selected.length) return;

        var fragment = document.createDocumentFragment();


        function addComparePrice(item, priceElement) {
  if (!item.handle) return;

  fetch('/products/' + encodeURIComponent(item.handle) + '.js')
    .then(function (response) {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    })
    .then(function (product) {
      var variants = product.variants || [];
      var prices = variants.map(function (variant) {
        return variant.price;
      });

      if (!prices.length) return;

      var lowestPrice = Math.min.apply(null, prices);

      var matchingVariant = variants.find(function (variant) {
        return variant.price === lowestPrice &&
          variant.compare_at_price > variant.price;
      });

      if (!matchingVariant) return;

      var compare = document.createElement('s');
      compare.className = 'grid-link__sale_price';
      compare.textContent = '$' +
        (matchingVariant.compare_at_price / 100).toLocaleString('en-AU', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

      priceElement.appendChild(document.createTextNode(' '));
      priceElement.appendChild(compare);
    })
    .catch(function (error) {
      console.warn('Compare price unavailable:', error);
    });
}


        selected.forEach(function (item) {
          var card = document.createElement('div');
          card.className =
            'grid__item large--one-quarter medium--one-quarter small--one-half';

          var link = document.createElement('a');
          link.className = 'grid-link text-center';
          link.href = item.url;

          var imageWrapper = document.createElement('span');
          imageWrapper.className = 'grid-link__image grid-link__image--product';

          var centered = document.createElement('span');
          centered.className = 'grid-link__image-centered';

          var img = document.createElement('img');
          img.src = item.featured_image && item.featured_image.url
            ? item.featured_image.url
            : (item.image || '');
          img.alt = item.title || '';

          centered.appendChild(img);
          imageWrapper.appendChild(centered);
          link.appendChild(imageWrapper);

          var name = document.createElement('p');
          name.className = 'grid-link__title';
          name.textContent = item.title;
          link.appendChild(name);

          var price = document.createElement('p');
          price.className = 'grid-link__meta';

          function formatPrice(value) {
  var amount = parseFloat(
    String(value).replace(/[^0-9.-]/g, '')
  );

  if (isNaN(amount)) return '';

  return '$' + amount.toLocaleString('en-AU', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

price.textContent = formatPrice(item.price);

          link.appendChild(price);
addComparePrice(item, price);
card.appendChild(link);
          fragment.appendChild(card);
        });

        originalCards.forEach(function (card) {
          if (fragment.children.length >= 4) return;

          var handle = card.getAttribute('data-product-handle');

          if (!handle || seen[handle]) return;

          seen[handle] = true;
          fragment.appendChild(card.cloneNode(true));
        });

        if (fragment.children.length) {
          grid.replaceChildren(fragment);
        }
      })
      .catch(function (error) {
        console.warn('Related products:', error);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRelatedProducts);
  } else {
    initRelatedProducts();
  }
})();